import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = {}, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            return {
                ...state,
                loading: true,
                waitting: action.waitting,
                action: commonTypes.ASYNC_START,
            }
        }

        case commonTypes.ASYNC_END: {
            return {
                ...state,
                action: commonTypes.ASYNC_END,
                waitting: commonTypes.ASYNC_END,
                loading: false,
            }
        }
        case types.LIST_PACKAGE: {
            return {
                ...state,
                action: types.LIST_PACKAGE,
                packages: action.status ? action.payload.packages : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }

        case types.DETAIL_PACKAGE: {
            return {
                ...state,
                action: types.DETAIL_PACKAGE,
                details: action.status ? action.payload.details : [],
                status: action.status,
                message: action.message,
            }
        }
        default:
            return state;
    }
}

